<div id="topPage" class="flex flex-col">
    <medpace-appbar [isRouterOutputLoad]="routerLoad()" class="flex-1" [displaySideBar]="!isAccessRequestPage()" />

    <medpace-footer [ngClass]="!isAccessRequestPage() ? 'footer-content' : ''" id="footer" />
</div>
